import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import ControlsStyles from '../Controls/Controls.styles';
import { DotsStyles } from '../Dots/Dots.styles';
import { hideScrollbars } from '@helpers/scrollbars';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  max-width: 100%;

  @media ${from(Device.Desktop)} {
    justify-content: flex-start;
  }

  ${ControlsStyles.Container} {
    flex-shrink: 0;
  }

  ${DotsStyles.Dots} {
    flex-shrink: 1;
    min-width: 1px;
    overflow-x: auto;
    justify-content: unset;
    flex-wrap: nowrap;
    position: relative;
    ${hideScrollbars}

    ${DotsStyles.Dot} {
      flex-shrink: 0;
    }
  }
`;
const PaginationStyles = {
    Container,
};
export default PaginationStyles;
